import { useEffect } from 'react';
import { TimelineMax, TweenMax } from 'gsap';
import { useAnimate } from '../utils';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';
import EfImg from 'elem/ui/ef-img';

const { EFPic } = createEFPic('/img/landingPage/');

export default function G(): JSX.Element {
    const { useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('landingPage');

    let powerInfoList = [
        {
            name: t('secG_Light'),
            type1: t('secG_Light_1'),
            type2: t('secG_Light_2'),
            type3: t('secG_Light_3'),
        },
        {
            name: t('secG_WiFiRouter'),
            type1: t('secG_WiFiRouter_1'),
            type2: t('secG_WiFiRouter_2'),
            type3: t('secG_WiFiRouter_3'),
        },
        {
            name: t('secG_TV'),
            type1: t('secG_TV_1'),
            type2: t('secG_TV_2'),
            type3: t('secG_TV_3'),
        },
        {
            name: t('secG_Refrigerator'),
            type1: t('secG_Refrigerator_1'),
            type2: t('secG_Refrigerator_2'),
            type3: t('secG_Refrigerator_3'),
        },
        {
            name: t('secG_Electrickettle'),
            type1: t('secG_Electrickettle_1'),
            type2: t('secG_Electrickettle_2'),
            type3: t('secG_Electrickettle_3'),
        },
        {
            name: t('secG_ElectricHeater'),
            type1: t('secG_ElectricHeater_1'),
            type2: t('secG_ElectricHeater_2'),
            type3: t('secG_ElectricHeater_3'),
        },
        {
            name: t('secG_ElectricOven'),
            type1: t('secG_ElectricOven_1'),
            type2: t('secG_ElectricOven_2'),
            type3: t('secG_ElectricOven_3'),
        },
        {
            name: t('secG_Microwave'),
            type1: t('secG_Microwave_1'),
            type2: t('secG_Microwave_2'),
            type3: t('secG_Microwave_3'),
        },
        {
            name: t('secG_AirConditioner'),
            type1: t('secG_AirConditioner_1'),
            type2: t('secG_AirConditioner_2'),
            type3: t('secG_AirConditioner_3'),
        },
        {
            name: t('secG_ClothesDryer'),
            type1: t('secG_ClothesDryer_1'),
            type2: t('secG_ClothesDryer_2'),
            type3: t('secG_ClothesDryer_3'),
        },
    ];

    if (locale === 'ca') {
        powerInfoList = [
            {
                name: t('secG_Light'),
                type1: t('secG_Light_1'),
                type0: t('secG_Light_0'),
                type2: t('secG_Light_2'),
                type3: t('secG_Light_3'),
            },
            {
                name: t('secG_WiFiRouter'),
                type1: t('secG_WiFiRouter_1'),
                type0: t('secG_WiFiRouter_0'),
                type2: t('secG_WiFiRouter_2'),
                type3: t('secG_WiFiRouter_3'),
            },
            {
                name: t('secG_TV'),
                type1: t('secG_TV_1'),
                type0: t('secG_TV_0'),
                type2: t('secG_TV_2'),
                type3: t('secG_TV_3'),
            },
            {
                name: t('secG_Refrigerator'),
                type1: t('secG_Refrigerator_1'),
                type0: t('secG_Refrigerator_0'),
                type2: t('secG_Refrigerator_2'),
                type3: t('secG_Refrigerator_3'),
            },
            {
                name: t('secG_Electrickettle'),
                type1: t('secG_Electrickettle_1'),
                type0: t('secG_Electrickettle_0'),
                type2: t('secG_Electrickettle_2'),
                type3: t('secG_Electrickettle_3'),
            },
            {
                name: t('secG_ElectricHeater'),
                type1: t('secG_ElectricHeater_1'),
                type0: t('secG_ElectricHeater_0'),
                type2: t('secG_ElectricHeater_2'),
                type3: t('secG_ElectricHeater_3'),
            },
            {
                name: t('secG_ElectricOven'),
                type1: t('secG_ElectricOven_1'),
                type0: t('secG_ElectricOven_0'),
                type2: t('secG_ElectricOven_2'),
                type3: t('secG_ElectricOven_3'),
            },
            {
                name: t('secG_Microwave'),
                type1: t('secG_Microwave_1'),
                type0: t('secG_Microwave_0'),
                type2: t('secG_Microwave_2'),
                type3: t('secG_Microwave_3'),
            },
            {
                name: t('secG_AirConditioner'),
                type1: t('secG_AirConditioner_1'),
                type0: t('secG_AirConditioner_0'),
                type2: t('secG_AirConditioner_2'),
                type3: t('secG_AirConditioner_3'),
            },
            {
                name: t('secG_ClothesDryer'),
                type1: t('secG_ClothesDryer_1'),
                type0: t('secG_ClothesDryer_0'),
                type2: t('secG_ClothesDryer_2'),
                type3: t('secG_ClothesDryer_3'),
            },
        ];
    }

    useEffect(() => {
        const { createScene, destroy, layoutH } = useAnimate();

        createScene({
            triggerElement: '.pageG_powerBox',
            triggerHook: 1,
            offset: 200,
            duration: (layoutH * 2) / 3,
        })
            .setTween(
                new TimelineMax().add(
                    TweenMax.to('.pageG_powerBox', 1, {
                        opacity: 1,
                    }),
                ),
            )
            .addTo(aniController);

        return () => destroy();
    }, []);

    return (
        <div className={`landing_page_G1 ${css.landing_page_G1}`}>
            <div className="pageG_powerBox">
                <div className="pageG_powerTitle">{t('secF_powerList')}</div>
                <div className="pageG_powerList">
                    <div className="pageG_powerRow pageG_powerRow_th">
                        <div className="powerRowItem"></div>
                        <div className="powerRowItem">
                            <div>
                                <EFPic
                                    name={
                                        locale === 'au'
                                            ? [`product/1.webp`, `product/1.png`]
                                            : locale === 'ca'
                                            ? ['DPU+TS(30A).png']
                                            : [`pc/g-5.webp`, `pc/g-5.png`]
                                    }
                                    className="powerItemImg"
                                />
                                <div className="powerItemTitle">{t('secG_item1_title1')}</div>
                            </div>
                        </div>
                        {locale === 'ca' && (
                            <div className="powerRowItem">
                                <div>
                                    <EfImg pc="https://websiteoss.ecoflow.com/upload/image/1723023730135/2_DP3%2BDHP2.png" className="powerItemImg" />
                                    <div className="powerItemTitle">{'2 × EcoFlow DELTA Pro 3 + 1 × Smart Home Panel 2'}</div>
                                </div>
                            </div>
                        )}
                        <div className="powerRowItem">
                            <div>
                                <EFPic name={locale === 'au' ? [`product/2.webp`, `product/2.png`] : [`pc/g-3.webp`, `pc/g-3.png`]} className="powerItemImg" />
                                <div className="powerItemTitle">{t('secG_item2_title1')}</div>
                            </div>
                        </div>
                        <div className="powerRowItem">
                            <div>
                                <EFPic name={locale === 'au' ? [`product/3.webp`, `product/3.png`] : [`pc/g-4.webp`, `pc/g-4.png`]} className="powerItemImg" />
                                <div className="powerItemTitle">{t('secG_item3_title1')}</div>
                            </div>
                        </div>
                    </div>
                    {(locale === 'au' ? powerInfoList?.slice(0, 5) : powerInfoList).map((item: any, index: number) => (
                        <div className="pageG_powerRow_tr" key={index}>
                            <div className="powerRowItem">
                                <span className="powerRowItemName">{item.name}</span>
                            </div>
                            <div className="powerRowItem">{item.type1}</div>
                            {locale === 'ca' && <div className="powerRowItem">{item.type0}</div>}
                            <div className="powerRowItem">{item.type2}</div>
                            <div className="powerRowItem">{item.type3}</div>
                        </div>
                    ))}
                </div>
                {locale === 'au' && <p className="memo">{t('secG_memo')}</p>}
            </div>
        </div>
    );
}
